import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-658976aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader loader--3"
}
const _hoisted_2 = {
  key: 1,
  class: "container purchase-container"
}
const _hoisted_3 = { class: "row gx-16" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  key: 1,
  class: "col-12"
}
const _hoisted_11 = {
  key: 2,
  class: "col-12"
}
const _hoisted_12 = {
  key: 0,
  class: "product-list"
}
const _hoisted_13 = { class: "fw-bold mb-0" }
const _hoisted_14 = { class: "me-4" }
const _hoisted_15 = { class: "product-item d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_17 = { class: "fw-bold px-16" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "available-products mt-24" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "text-primary" }
const _hoisted_25 = { class: "items-grid mb-24" }
const _hoisted_26 = {
  key: 0,
  class: "col"
}
const _hoisted_27 = { class: "d-flex justify-content-between flex-column" }
const _hoisted_28 = { class: "product-container card position-relative" }
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = ["aria-label", "onClick"]
const _hoisted_31 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-subtitle mb-2 text-muted" }, "Producto", -1))
const _hoisted_33 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_35 = { class: "fw-bold px-16 text-primary" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "icon icon-check-ring-round-light text-xxl text-success bg-white fw-bold"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_42 = { class: "fw-bold px-16 text-primary" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "text-primary" }
const _hoisted_47 = { class: "items-grid mb-24" }
const _hoisted_48 = {
  key: 0,
  class: "col"
}
const _hoisted_49 = { class: "d-flex justify-content-between flex-column" }
const _hoisted_50 = { class: "product-container card position-relative" }
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = ["aria-label", "onClick"]
const _hoisted_53 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_54 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_56 = { class: "fw-bold px-16 text-primary" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_58 = {
  key: 0,
  class: "icon icon-check-ring-round-light text-xxl text-success bg-white fw-bold"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold px-16 text-primary" }, "0", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col" }
const _hoisted_67 = { class: "text-primary" }
const _hoisted_68 = { class: "items-grid mb-24" }
const _hoisted_69 = {
  key: 0,
  class: "col"
}
const _hoisted_70 = { class: "d-flex justify-content-between flex-column" }
const _hoisted_71 = { class: "product-container card position-relative" }
const _hoisted_72 = { class: "card-body" }
const _hoisted_73 = ["aria-label", "onClick"]
const _hoisted_74 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_75 = {
  key: 0,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_76 = {
  key: 1,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_77 = {
  key: 2,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_78 = {
  key: 3,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_79 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_81 = { class: "fw-bold px-16 text-primary" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_83 = {
  key: 0,
  class: "icon icon-check-ring-round-light text-xxl text-success bg-white fw-bold"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, null, -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold px-16 text-primary" }, "0", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col" }
const _hoisted_92 = { class: "text-primary" }
const _hoisted_93 = { class: "items-grid mb-24" }
const _hoisted_94 = {
  key: 0,
  class: "col"
}
const _hoisted_95 = { class: "d-flex justify-content-between flex-column" }
const _hoisted_96 = { class: "product-container card position-relative" }
const _hoisted_97 = { class: "card-body" }
const _hoisted_98 = ["aria-label", "onClick"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-subtitle mb-2 text-muted" }, "Otros", -1))
const _hoisted_100 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_102 = { class: "fw-bold px-16 text-primary" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_104 = {
  key: 0,
  class: "icon icon-check-ring-round-light text-xxl text-success bg-white fw-bold"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, null, -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 0,
  class: "product-item d-flex align-items-center mt-8"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-remove text-xs"
}, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold px-16 text-primary" }, "0", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-xs"
}, null, -1))
const _hoisted_111 = { class: "col-12" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-send-hor me-12"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_protocol_name = _resolveComponent("v-protocol-name")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "fullscreen",
    onClosed: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nueva autorización de compra')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (_ctx.status === 'loading')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.hasProtocol())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Protocolo:')), 1),
                          _createVNode(_component_v_protocol_name, {
                            color: _ctx.getCurrentProtocolPhaseTreatment().protocolPhase.protocol.type,
                            text: _ctx.getCurrentProtocolPhaseTreatment().protocolPhase.protocol.name
                          }, null, 8, ["color", "text"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_form_group_input_text, {
                            disabled: true,
                            label: _ctx.$t('Fase'),
                            value: _ctx.getCurrentProtocolPhaseTreatment().protocolPhase.name,
                            class: "mb-40",
                            type: "text"
                          }, null, 8, ["label", "value"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_form_group_select, {
                      label: _ctx.$t('Duración del tratamiento*'),
                      "yup-errors-variable": _ctx.errors.treatmentDuration,
                      class: "mb-40"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.treatmentDuration,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.treatmentDuration) = $event)),
                          class: _normalizeClass({'is-invalid': !!_ctx.errors.treatmentDuration}),
                          label: _ctx.$t('Introducir días'),
                          options: _ctx.treatmentDurationOptions,
                          "select-on-key-codes": [188, 13]
                        }, {
                          "no-options": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class", "label", "options"])
                      ]),
                      _: 1
                    }, 8, ["label", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_form_group_select, {
                      label: _ctx.$t('Posología*'),
                      "yup-errors-variable": _ctx.errors.posology,
                      class: "mb-40"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.posology,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.posology) = $event)),
                          class: _normalizeClass({'is-invalid': !!_ctx.errors.posology}),
                          options: _ctx.posologyOptions,
                          placeholder: _ctx.$t('Introducir dosis'),
                          "select-on-key-codes": [188, 13]
                        }, {
                          "no-options": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_alert, {
                      role: "alert",
                      variant: "secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(// eslint-disable-next-line max-len
                _ctx.$t('Para {treatmentDuration} días y {posology} tomas diarias ({dose} dosis) de tratamiento, puedes autorizar hasta un máximo de', {
                  treatmentDuration: _ctx.treatmentDuration,
                  posology: _ctx.posology,
                  dose: _ctx.treatmentDuration * _ctx.posology,
                })) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(// eslint-disable-next-line max-len
                  _ctx.$t('{suggestedBoxes} cajas ({productSuggestedBoxes} sobres)', {
                    suggestedBoxes: _ctx.suggestedBoxes,
                    suggestedBoxes: _ctx.suggestedBoxes,
                    productSuggestedBoxes: _ctx.suggestedBoxes * 10,
                  })), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.hasProtocol())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_v_alert, {
                          role: "alert",
                          variant: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.recommendationMessage), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.cartProductsQuantity > _ctx.suggestedBoxes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_v_alert, {
                          role: "alert",
                          variant: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Tienes más productos en la cesta de los permitidos. Elimina alguno.')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.can('professional.product.index'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('Productos')), 1),
                      (_ctx.showAllProductList())
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.productList, (product) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: product.id,
                              class: "product-container-item d-flex justify-content-between align-items-center text-primary py-8 px-16"
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(product.name) + " (" + _toDisplayString(product.type) + ") -", 1),
                                _createElementVNode("span", null, _toDisplayString(product.doses) + " " + _toDisplayString(_ctx.$t('dosis durante')) + " " + _toDisplayString(product.days) + " " + _toDisplayString(_ctx.$t('días')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_v_button, {
                                  "aria-label": _ctx.$t('Restar producto'),
                                  class: "text-primary px-4 py-4",
                                  variant: "icon",
                                  onClick: ($event: any) => (_ctx.deductQuantity(product.product_id))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 2
                                }, 1032, ["aria-label", "onClick"]),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(product.quantity) + " " + _toDisplayString(product.quantity === 1 ? 'caja' : 'cajas'), 1),
                                _createVNode(_component_v_button, {
                                  "aria-label": _ctx.$t('Sumar producto'),
                                  disabled: _ctx.limitReached,
                                  class: "text-primary px-4 py-4",
                                  variant: "icon",
                                  onClick: ($event: any) => (_ctx.addQuantity(product.product_id))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 2
                                }, 1032, ["aria-label", "disabled", "onClick"])
                              ])
                            ]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('Para añadir productos tienes que introducir la duración del tratamiento y la posología.')), 1)),
                      (!_ctx.productList.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('Selecciona los productos necesarios para crear la autorización de compra')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$t('Productos')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProducts, (product) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: product.id
                            }, [
                              (product.type === 'producto'
                // && product.name !== 'C\u00e1psulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                // && product.name !== 'Cápsulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 cápsulas)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 c\u00e1psulas)'
                && product.name !== 'BATIDO PROTEICO VEGANO PROAGE ON SABOR PIÑA'
                && product.name !== 'BATIDO PROTEICO VEGANO PROAGE ON PLUS SABOR PIÑA'
                // && product.name !== 'BATIDO PROTEICO VEGANO PROAGE ON PLUS SABOR VAINILLA'
                // && product.name !== 'BATIDO PROTEICO VEGANO PROAGE ON SABOR CHOCOLATE'
                // && product.name !== 'BATIDO PROTEICO VEGANO PROAGE ON PLUS SABOR CHOCOLATE'
                && product.name !== 'Menozen Dra. Zuramis'
                && product.name !== 'Perlas veganas DHA 250 mg + Vitamina D 2000 UI (60u)'
                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("a", {
                                            "aria-label": _ctx.$t('Añadir nuevo producto'),
                                            class: "card-title h6 stretched-link text-decoration-none",
                                            onClick: _withModifiers(($event: any) => (_ctx.addProduct(product)), ["prevent"])
                                          }, _toDisplayString(product.name), 9, _hoisted_30),
                                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('10 sobres por caja')), 1),
                                          _hoisted_32
                                        ])
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (productSelected) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: productSelected.product_id
                                        }, [
                                          (productSelected.product_id === product.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Restar producto'),
                                                  class: "text-primary px-4 py-4",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_34
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "onClick"]),
                                                _createElementVNode("span", _hoisted_35, _toDisplayString(productSelected.quantity) + " " + _toDisplayString(productSelected.quantity === 1 ? 'caja' : 'cajas'), 1),
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Sumar producto'),
                                                  disabled: _ctx.limitReached,
                                                  class: "text-primary px-4 py-4 me-16",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.addQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_36
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "disabled", "onClick"]),
                                                (_ctx.checkProductInList(product.id))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (!_ctx.checkProductInList(product.id))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Restar producto'),
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_41
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "onClick"]),
                                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('0 cajas')), 1),
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Sumar producto'),
                                              disabled: _ctx.limitReached,
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.addProduct(product))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_43
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "disabled", "onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("h4", _hoisted_46, _toDisplayString(_ctx.$t('Suplementación')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProducts, (product) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: product.id
                            }, [
                              (product.type === 'suplementacion'
                // && product.name !== 'C\u00e1psulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                // && product.name !== 'Cápsulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                && product.name !== 'Perlas veganas DHA 250 mg + Vitamina D 2000 UI (60u)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 cápsulas)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 c\u00e1psulas)'
                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                          _createElementVNode("a", {
                                            "aria-label": _ctx.$t('Añadir nuevo producto'),
                                            class: "card-title h6 stretched-link text-decoration-none",
                                            onClick: _withModifiers(($event: any) => (_ctx.addProduct(product)), ["prevent"])
                                          }, _toDisplayString(product.name), 9, _hoisted_52),
                                          _createElementVNode("p", _hoisted_53, _toDisplayString(product.type === 'suplementacion' ? _ctx.$t('Suplementación') : _ctx.$t('Producto')), 1)
                                        ])
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (productSelected) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: productSelected.product_id
                                        }, [
                                          (productSelected.product_id === product.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Restar producto'),
                                                  class: "text-primary px-4 py-4",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_55
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "onClick"]),
                                                _createElementVNode("span", _hoisted_56, _toDisplayString(productSelected.quantity), 1),
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Sumar producto'),
                                                  class: "text-primary px-4 py-4 me-16",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.addQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_57
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "onClick"]),
                                                (_ctx.checkProductInList(product.id))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (!_ctx.checkProductInList(product.id))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Restar producto'),
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_62
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "onClick"]),
                                            _hoisted_63,
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Sumar producto'),
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.addProduct(product))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_64
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("h4", _hoisted_67, _toDisplayString(_ctx.$t('Packs')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProducts, (product) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: product.id
                            }, [
                              (product.type === 'packs'
                // && product.name !== 'C\u00e1psulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                // && product.name !== 'Cápsulas Veganas de Ubiquinol Kaneka 100 mg (60u)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 cápsulas)'
                // && product.name !== 'Astaxantina 8 mg + Vitamina E 12 mg (60 c\u00e1psulas)'
                && product.name !== 'Pack Dieta Proteinada ON para 32 días. ¡Pierde más de 10 kg!'
                && product.name !== 'Pack Los Favoritos de Escassi'
                && product.name !== 'Pack Especial Navidad: Sabores Café, Vainilla y Variados (Plan Reset 1, 2, 3 ó 4)'
                && product.name.trim()
                !== 'Pack Reset Fresa, Piña y Variados (válido para Protocolo Reset 1, 2 y 3)'
                && product.name.trim()
                !== 'Pack Reset Fresa, Café, Piña y Variados (válido para Protocolo Reset 1, 2, 3 y 4)'
                && product.name.trim()
                // !== 'Pack Especial Navidad: Sabores Café, Vainilla y Variados (Plan Reset 1, 2, 3 ó 4)'
                && product.name.trim()
                !== 'Pack Dieta Proteinada ON+ ¡Pierde más de 10 kg y refuerza tu sistema inmune!')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, [
                                          _createElementVNode("a", {
                                            "aria-label": _ctx.$t('Añadir nuevo producto'),
                                            class: "card-title h6 stretched-link text-decoration-none",
                                            onClick: _withModifiers(($event: any) => (_ctx.addProduct(product)), ["prevent"])
                                          }, _toDisplayString(product.name), 9, _hoisted_73),
                                          _createElementVNode("p", _hoisted_74, _toDisplayString(product.type === 'packs' ? _ctx.$t('Packs') : _ctx.$t('Producto')), 1),
                                          (product.name === 'Pack Bienestar Intestinal')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_75, " Probiotic Activity y L-Glutamina Kyowa 200 g "))
                                            : _createCommentVNode("", true),
                                          (product.name === 'Pack Antiviral Proage')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_76, " PEA+ 300 mg y Quercetina 200 mg "))
                                            : _createCommentVNode("", true),
                                          (product.name === 'Pack Antiviral Plus Proage')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_77, " PEA+ 300 mg, Quercetina 200 mg, Bisglicinato de Zinc 15 mg y DHA 500 mg + Vitamina D 2000 UI "))
                                            : _createCommentVNode("", true),
                                          (product.name === 'Pack Los Favoritos de Escassi')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_78, " 2 cajas de Batidos Proage ON+ Sabores Variados, 1 caja de Batidos Proage ON+ Café, Astaxantina + Vitamina E, Complejo B Metilado, Bisglicinato de Magnesio, PEA+, Ubiquinol y 1 botella mezcladora Proage "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (productSelected) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: productSelected.product_id
                                        }, [
                                          (productSelected.product_id === product.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Restar producto'),
                                                  class: "text-primary px-4 py-4",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_80
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "onClick"]),
                                                _createElementVNode("span", _hoisted_81, _toDisplayString(productSelected.quantity), 1),
                                                _createVNode(_component_v_button, {
                                                  "aria-label": _ctx.$t('Sumar producto'),
                                                  class: "text-primary px-4 py-4 me-16",
                                                  variant: "icon",
                                                  onClick: ($event: any) => (_ctx.addQuantity(product.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_82
                                                  ]),
                                                  _: 2
                                                }, 1032, ["aria-label", "onClick"]),
                                                (_ctx.checkProductInList(product.id))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_85))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (!_ctx.checkProductInList(product.id))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Restar producto'),
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_87
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "onClick"]),
                                            _hoisted_88,
                                            _createVNode(_component_v_button, {
                                              "aria-label": _ctx.$t('Sumar producto'),
                                              class: "text-primary px-4 py-4",
                                              variant: "icon",
                                              onClick: ($event: any) => (_ctx.addProduct(product))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_89
                                              ]),
                                              _: 2
                                            }, 1032, ["aria-label", "onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        (!_ctx.productToHideNames.includes('Botella mezcladora con funda negra'))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("h4", _hoisted_92, _toDisplayString(_ctx.$t('Otros')), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_93, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProducts, (product) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: product.id
                                  }, [
                                    (product.type === 'otros')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                          _createElementVNode("div", _hoisted_95, [
                                            _createElementVNode("div", _hoisted_96, [
                                              _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("a", {
                                                  "aria-label": _ctx.$t('Añadir nuevo producto'),
                                                  class: "card-title h6 stretched-link text-decoration-none",
                                                  onClick: _withModifiers(($event: any) => (_ctx.addProduct(product)), ["prevent"])
                                                }, _toDisplayString(product.name), 9, _hoisted_98),
                                                _hoisted_99
                                              ])
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (productSelected) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: productSelected.product_id
                                              }, [
                                                (productSelected.product_id === product.id)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                      _createVNode(_component_v_button, {
                                                        "aria-label": _ctx.$t('Restar producto'),
                                                        class: "text-primary px-4 py-4",
                                                        variant: "icon",
                                                        onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_101
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["aria-label", "onClick"]),
                                                      _createElementVNode("span", _hoisted_102, _toDisplayString(productSelected.quantity), 1),
                                                      _createVNode(_component_v_button, {
                                                        "aria-label": _ctx.$t('Sumar producto'),
                                                        class: "text-primary px-4 py-4 me-16",
                                                        variant: "icon",
                                                        onClick: ($event: any) => (_ctx.addQuantity(product.id))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_103
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["aria-label", "onClick"]),
                                                      (_ctx.checkProductInList(product.id))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            }), 128)),
                                            (!_ctx.checkProductInList(product.id))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                  _createVNode(_component_v_button, {
                                                    "aria-label": _ctx.$t('Restar producto'),
                                                    class: "text-primary px-4 py-4",
                                                    variant: "icon",
                                                    onClick: ($event: any) => (_ctx.deductQuantity(product.id))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_108
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["aria-label", "onClick"]),
                                                  _hoisted_109,
                                                  _createVNode(_component_v_button, {
                                                    "aria-label": _ctx.$t('Sumar producto'),
                                                    class: "text-primary px-4 py-4",
                                                    variant: "icon",
                                                    onClick: ($event: any) => (_ctx.addProduct(product))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_110
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["aria-label", "onClick"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_111, [
            _createVNode(_component_v_alert, {
              variant: "secondary",
              role: "alert"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(// eslint-disable-next-line max-len
            _ctx.$t('Autorización botella')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_button, {
            "aria-label": _ctx.$t('Cancelar'),
            class: "me-24",
            "data-bs-dismiss": "modal",
            variant: "link-secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(_component_v_button, {
            "aria-label": _ctx.$t('Añadir'),
            disabled: !_ctx.meta.valid || _ctx.accepted || _ctx.cartProductsQuantity > _ctx.suggestedBoxes,
            "is-loading": _ctx.accepted,
            class: "btn-icon",
            variant: "secondary",
            onClick: _ctx.confirmCreatePurchaseAuthorization
          }, {
            default: _withCtx(() => [
              _hoisted_112,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Enviar autorización de compra')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "disabled", "is-loading", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClosed"]))
}